
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/integrations/theme-scoping",
      function () {
        return require("private-next-pages/material-ui/integrations/theme-scoping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/integrations/theme-scoping"])
      });
    }
  